import { isString } from "../../../../../../../../common/utils/strings";
const quote = (val) => {
  if (isString(val)) {
    return `"${val}"`;
  }
  return val;
};

export const autoIncrementTemplate = (paginationVariableName, startValue, incrementValue) => {
  return `const incrementValue=${incrementValue}; const startValue=${startValue};
          return ${paginationVariableName} !== undefined ? ${paginationVariableName} + incrementValue : startValue;`;
};

export const responseBasedTemplate = (defaultValue, jsonPathToResponseValue) => {
  return `const _jsonResponsePath=${quote(jsonPathToResponseValue)};
          const _defaultValue=${quote(defaultValue)};
          const _nextCursor = path(jsonResponse, _jsonResponsePath);
          return _nextCursor !== undefined ? _nextCursor : _defaultValue;
          `;
};

export const customTemplate = (variableName) => {
  return `/**
 * CUSTOM PAGINATION SCRIPTS MUST ALWAYS RETURN A VALUE.
 * THE RETURNED VALUE REPRESENTS THE UPDATED PAGINATION STATE.
 *
 * AVAILABLE VARIABLES:
 *   - response: the raw response object, including data and headers
 *   - getIssue(): returns the issue object from context (if available)
 *   - scope variables: provided from the request (aliases: context, jsonContext)
 *   - YOUR_PAGINATION_VARIABLE_NAME: the pagination state from the previous run
 *   - path: JSONPath helper → path(response, "$.field.path") to extract values
 *
 * IMPORTANT:
 *   - For parent actions, the returned value will always update the response
 *   - For paginated responses, use a scope variable as your pagination counter.
 *
 * EXAMPLE PAGINATION LOGIC:
 *   The snippet below checks whether the pagination variable (for example: "page")
 *   is already defined. If it exists, we increment it by 1. If not, we start at 0.
 *
 *   First run  → scope.page is undefined → returns 0
 *   Second run → scope.page = 0 → returns 1
 *   Third run  → scope.page = 1 → returns 2
 *   …and so on.
 */
 return ${variableName} !== undefined ? ${variableName} + 1: 0;
`;
};
